import React, { useState } from "react";
import "./style.css";
import {
  Instagram,
  Youtube,
  Telegram,
  Linkedin,
  Whatsapp,
} from "react-bootstrap-icons";

const FooterA = () => {
  const [overInstagram, setOverInstagram] = useState(false);
  const [overWhatsapp, setOverWhatsapp] = useState(false);

  const [overLinkedin, setOverLinkedin] = useState(false);
  const [overTelegram, setOverTelegram] = useState(false);
  const [overYoutube, setOverYoutube] = useState(false);

  const onLink = (link) => {
    window.open(link, "_blank", " noopener");
  };
  return (
    <div className="all-footer-a">
      <div className="footer-a container border-bottom border-gray py-5">
        {/* <div className="newsletters p-0">
          <p className="mb-0 ps-1 text-nowrap">
            اولین نفری باشید که از اخبار و جشنواره های جذاب داپ‌اَپ مطلع می شوید
          </p>
          <form action="" className="form-newsletters bg-white ">
            <Envelope className="ms-2 border-start border-gray mx-2 fs-3 ps-2" />
            <input type="text" className="border-0 " />
            <button className="py-2 px-1 ps-2 text-white text-nowrap ">
              {" "}
              عضویت در خبرنامه
            </button>
          </form>
        </div> */}
        <div className="social-media-icons">
          <button
            onMouseOver={() => setOverInstagram(true)}
            onMouseLeave={() => setOverInstagram(false)}
            className="p-2 border rounded-circle border-dark fs-4 mx-1 link-icon-social-media"
            onClick={() => onLink("https://www.instagram.com/daapapp/")}
          >
            <Instagram
              className="icons-social text-dark"
              color={overInstagram ? "#c32aa3" : ""}
            />
          </button>

          <button
            onMouseOver={() => setOverYoutube(true)}
            onMouseLeave={() => setOverYoutube(false)}
            className="p-2 border rounded-circle border-dark fs-4 mx-1 link-icon-social-media"
            onClick={() =>
              onLink("https://www.youtube.com/channel/UCTTeEyjHDg9XQoOemDXOf6A")
            }
          >
            <Youtube
              className="icons-social  text-dark"
              size={20}
              color={overYoutube ? "#ff0000" : ""}
            />
          </button>
          <button
            onMouseOver={() => setOverTelegram(true)}
            onMouseLeave={() => setOverTelegram(false)}
            className="p-2 border rounded-circle border-dark fs-4 mx-1 link-icon-social-media"
            onClick={() => onLink("https://t.me/daapapp")}
          >
            <Telegram
              className=" icons-social text-dark"
              size={20}
              color={overTelegram ? "#0088cc" : ""}
            />
          </button>

          <button
            onMouseOver={() => setOverLinkedin(true)}
            onMouseLeave={() => setOverLinkedin(false)}
            className="p-2 border rounded-circle border-dark fs-4 mx-1 link-icon-social-media"
            onClick={() => onLink("https://www.linkedin.com/company/daapapp")}
          >
            <Linkedin
              className=" icons-social text-dark"
              size={20}
              color={overLinkedin ? "#0a66c2" : ""}
            />
          </button>

          <button
            onMouseOver={() => setOverWhatsapp(true)}
            onMouseLeave={() => setOverWhatsapp(false)}
            className="p-2 border rounded-circle  border-dark fs-4 mx-1 link-icon-social-media"
            onClick={() => onLink("https://wa.me/989013568657")}
          >
            <Whatsapp
              className="icons-social text-dark"
              size={20}
              color={overWhatsapp ? " #25d366" : ""}
            />
          </button>
        </div>
      </div>
    </div>
  );
};

export default FooterA;
